import { PaymentTypeSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  payment_type: {
    other: {
      'ui:widget': PaymentTypeSelectionWidget,
    },
    default: {
      'ui:widget': PaymentTypeSelectionWidget,
    },
  },
});

export default uiSchema;
